// extracted by mini-css-extract-plugin
export default {"installedModels":"installedModels__XW3il6","saveButton":"saveButton__OLj2CO","modelName":"modelName__uE0cHV"};